// "Your briefing is ready" strip, shown at the top of whatever page someone opens
// first each day (Home, Clock, anywhere) until they open My Briefing. Deliberately a
// banner, not a pop-up: it never blocks anything (asked 2026-10-24).
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getMyBriefingStatus } from '../services/api';

function BriefingBanner() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  const check = useCallback(async () => {
    try {
      const res = await getMyBriefingStatus();
      setShow(!!res.data.show_banner);
    } catch (e) {
      setShow(false);
    }
  }, []);

  // Re-check on route changes (opening the briefing clears it) and when the app
  // comes back on screen, which is how a new day starts on a phone left open overnight.
  useEffect(() => { if (user) check(); }, [user, location.pathname, check]);
  useEffect(() => {
    const onVisible = () => { if (document.visibilityState === 'visible' && user) check(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, [user, check]);

  if (!user || !show || location.pathname === '/briefing') return null;

  return (
    <div
      onClick={() => navigate('/briefing')}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter') navigate('/briefing'); }}
      style={{
        backgroundColor: '#ecfdf5',
        borderBottom: '2px solid #10b981',
        padding: '10px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        cursor: 'pointer',
        flexWrap: 'wrap',
      }}
    >
      <span style={{ fontSize: '16px' }}>☀️</span>
      <span style={{ fontSize: '14px', fontWeight: 600, color: '#065f46' }}>
        Your briefing for today is ready.
      </span>
      <span style={{ fontSize: '12px', color: '#047857', textDecoration: 'underline' }}>
        See where you left off
      </span>
    </div>
  );
}

export default BriefingBanner;
